export default __webpack_public_path__ + "a255c0b066e8455cedb2e7ba897dd083.svg";